var exports = {
  "V": "grid__ts-CrO",
};

module.exports = exports;
